export default function selectCardinalPlural(number: number, forms: string[]): string {
	return number === 1 ? forms[0] : forms[1];
}
